import './MenuSeparator.css'

export function MenuSeparator() {
  return (
    <div
      className="menu-separator"
      role="separator"
      aria-orientation="horizontal"
    />
  )
}
